import { putProjectNavMode } from '@gonfalon/openapi/operations/putProjectNavMode';

import { createMutationHook } from '../internal/createMutationHook';

/**
 * Records the mode the member picked in the nav mode switcher.
 *
 * The caller owns the optimistic update and its rollback, because the value
 * lives in `ProjectNavModePreferenceProvider` rather than in the query cache:
 * nothing reads this preference from the server after the page loads, so there
 * is no cache entry for a write to keep honest.
 *
 * Serialized on a shared scope. Two writes in flight can settle in either order
 * and the server keeps whichever lands last, so a quick agent-then-code toggle
 * could otherwise leave the server holding agent.
 */
export const usePutProjectNavMode = createMutationHook(putProjectNavMode, {
  scope: { id: 'projectNavMode' },
});
